const GRAPH_RANGE = {
  LAST_WEEK: 'LAST_WEEK',
  FOUR_WEEKS: 'FOUR_WEEKS',
  FOUR_MONTHS: 'FOUR_MONTHS',
};

export default GRAPH_RANGE;
